import Home from "../pages/home";
import ProtectedRoute from "../pages/protected";
import Dashboard from "../pages/dashboard";
import UrlPage from "../pages/url";

import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState } from "react";


const AllRouter = () => {

  const [inputValue, setInputValue] = useState("");


  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<Home inputValue = {inputValue} setInputValue={setInputValue} />} />
          <Route exact path="/shopify" element={<UrlPage inputValue = {inputValue} />} />
          <Route exact path="/dashboard" element={<ProtectedRoute> <Dashboard /> </ProtectedRoute>} />         
          <Route exact path="*" element={<h1> 404 Error ! </h1>} />
        </Routes>
      </BrowserRouter>
    </>
  );
};
export default AllRouter;
